import { addCreativeGroupV2 } from "api/creative_group_v2_add";
import { ID, CreativeGroupShortV2 } from "models";

export const createGroup = async (
  group: CreativeGroupShortV2
): Promise<ID> => {
  const res = await addCreativeGroupV2(group);
  return res.data.data.id as ID;
};